import type { UnitInfoSchenckScreenInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';
import type { SchenckScreenUnitInfoDataMapInterface } from './unitInfoData';

export const TypeOfScreenings: string[] = ['Dry', 'Wet'];

export const nbrOfDecksOptions = [1, 2];

export const getDefaultData = (
  unitInfoData: SchenckScreenUnitInfoDataMapInterface,
): UnitInfoSchenckScreenInterface => {
  if (!unitInfoData.models || !unitInfoData.configurations) {
    throw new Error('expected models and configurations to be set');
  }

  return {
    modelName: Object.keys(unitInfoData.models)[1],
    width: Object.values(unitInfoData.models)[1].width,
    length: Object.values(unitInfoData.models)[1].length,
    nbrOfDecks: 2,
    deckList: {
      0: {
        separationSize: 25,
        screeningElement: {
          name: Object.values(unitInfoData.configurations.screeningMediaIds)[0]
            .name,
          value: Object.values(unitInfoData.configurations.screeningMediaIds)[0]
            .value,
        },
        openArea: 30,
        particleShape: {
          name: Object.values(unitInfoData.configurations.particleShapes)[0]
            .name,
          value: Object.values(unitInfoData.configurations.particleShapes)[0]
            .value,
        },
        efficiency: {
          name: Object.values(unitInfoData.configurations.efficiencyParams)[1]
            .name,
          value: Object.values(unitInfoData.configurations.efficiencyParams)[1]
            .value,
        },
        efficiencyNumber: 80,
        display: { separationSize: true },
      },
      1: {
        separationSize: 16,
        screeningElement: {
          name: Object.values(unitInfoData.configurations.screeningMediaIds)[0]
            .name,
          value: Object.values(unitInfoData.configurations.screeningMediaIds)[0]
            .value,
        },
        openArea: 30,
        particleShape: {
          name: Object.values(unitInfoData.configurations.particleShapes)[0]
            .name,
          value: Object.values(unitInfoData.configurations.particleShapes)[0]
            .value,
        },
        efficiency: {
          name: Object.values(unitInfoData.configurations.efficiencyParams)[1]
            .name,
          value: Object.values(unitInfoData.configurations.efficiencyParams)[1]
            .value,
        },
        efficiencyNumber: 80,
        display: { separationSize: true },
      },
    },
    scalpingScreen: false,
    wetScreening: false,
    materialType: {
      name: Object.values(unitInfoData.configurations.rockMaterials)[0].name,
      value: Object.values(unitInfoData.configurations.rockMaterials)[0].value,
    },
    moisture: 0,
    newMoisture: false,
    parallelUnits: 1,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayUnitScreenName: true,
      displayLoad: true,
      displayNbrOfDecks: false,
      displaySeparationSize: true,
      displayWetScreening: false,
    },
  };
};

export class SchenckScreenConfig extends BaseUnitConfig {
  static getDefaultData(
    params?: UnitConfigParams,
  ): UnitInfoSchenckScreenInterface {
    const unitInfoData = params?.data as
      SchenckScreenUnitInfoDataMapInterface | undefined;

    if (!unitInfoData?.models || !unitInfoData?.configurations) {
      throw new Error('expected models and configurations to be set');
    }

    return {
      modelName: Object.keys(unitInfoData.models)[1],
      width: Object.values(unitInfoData.models)[1].width,
      length: Object.values(unitInfoData.models)[1].length,
      nbrOfDecks: 2,
      deckList: {
        0: {
          separationSize: 25,
          screeningElement: {
            name: Object.values(
              unitInfoData.configurations.screeningMediaIds,
            )[0].name,
            value: Object.values(
              unitInfoData.configurations.screeningMediaIds,
            )[0].value,
          },
          openArea: 30,
          particleShape: {
            name: Object.values(unitInfoData.configurations.particleShapes)[0]
              .name,
            value: Object.values(unitInfoData.configurations.particleShapes)[0]
              .value,
          },
          efficiency: {
            name: Object.values(unitInfoData.configurations.efficiencyParams)[1]
              .name,
            value: Object.values(
              unitInfoData.configurations.efficiencyParams,
            )[1].value,
          },
          efficiencyNumber: 80,
          display: { separationSize: true },
        },
        1: {
          separationSize: 16,
          screeningElement: {
            name: Object.values(
              unitInfoData.configurations.screeningMediaIds,
            )[0].name,
            value: Object.values(
              unitInfoData.configurations.screeningMediaIds,
            )[0].value,
          },
          openArea: 30,
          particleShape: {
            name: Object.values(unitInfoData.configurations.particleShapes)[0]
              .name,
            value: Object.values(unitInfoData.configurations.particleShapes)[0]
              .value,
          },
          efficiency: {
            name: Object.values(unitInfoData.configurations.efficiencyParams)[1]
              .name,
            value: Object.values(
              unitInfoData.configurations.efficiencyParams,
            )[1].value,
          },
          efficiencyNumber: 80,
          display: { separationSize: true },
        },
      },
      scalpingScreen: false,
      wetScreening: false,
      materialType: {
        name: Object.values(unitInfoData.configurations.rockMaterials)[0].name,
        value: Object.values(unitInfoData.configurations.rockMaterials)[0]
          .value,
      },
      ...BaseUnitConfig.getBaseDefaults(),
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayUnitScreenName: true,
        displayLoad: true,
        displayRiskLevel: false,
        displayNbrOfDecks: false,
        displaySeparationSize: true,
        displayWetScreening: false,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 4;
  }
}

export const schenckScreenConfig = new SchenckScreenConfig();
